import { Component, Input } from '@angular/core';

import { StepState } from '../step.component';
export class TdStepHeaderComponent {
/**
 * Number assigned to [TdStepHeaderComponent].
 */
number: number;
/**
 * active?: boolean
 * Sets for active/inactive states on header.
 */
active: boolean;
/**
 * disabled?: boolean
 * Sets styles for disabled state on icon and header.
 */
disabled: boolean;
/**
 * state?: StepState or ['none' | 'required' | 'complete']
 * Sets styles for state of header.
 * Defaults to [StepState.None | 'none'].
 */
state: StepState = StepState.None;
/**
 * Returns 'true' if [state] equals to [StepState.Complete | 'complete'], else 'false'.
 * @return {?}
 */
isComplete(): boolean {
    return this.state === StepState.Complete;
  }
/**
 * Returns 'true' if [state] equals to [StepState.Required | 'required'], else 'false'.
 * @return {?}
 */
isRequired(): boolean {
    return this.state === StepState.Required;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-step-header',
  styleUrls: ['./step-header.component.css' ],
  templateUrl: './step-header.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'number': [{ type: Input, args: ['number', ] },],
'active': [{ type: Input, args: ['active', ] },],
'disabled': [{ type: Input, args: ['disabled', ] },],
'state': [{ type: Input, args: ['state', ] },],
};
}

function TdStepHeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdStepHeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdStepHeaderComponent.ctorParameters;
/** @type {?} */
TdStepHeaderComponent.propDecorators;
/**
 * Number assigned to [TdStepHeaderComponent].
 * @type {?}
 */
TdStepHeaderComponent.prototype.number;
/**
 * active?: boolean
 * Sets for active/inactive states on header.
 * @type {?}
 */
TdStepHeaderComponent.prototype.active;
/**
 * disabled?: boolean
 * Sets styles for disabled state on icon and header.
 * @type {?}
 */
TdStepHeaderComponent.prototype.disabled;
/**
 * state?: StepState or ['none' | 'required' | 'complete']
 * Sets styles for state of header.
 * Defaults to [StepState.None | 'none'].
 * @type {?}
 */
TdStepHeaderComponent.prototype.state;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
